import { styled, Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const heading = {
  color: colors.gray600,
  marginBottom: "24px",
  marginTop: "32px !important",
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
};

const styles = makeStyles(() => ({
  formHeading: {
    ...heading,
  },
  formHeadingFirstTitle: {
    ...heading,
    marginTop: "16px !important",
  },
  divider: {
    marginTop: "32px",
  },
}));

export const FieldContainer = styled(Grid)(() => ({
  padding: "0px 0px",
}));

export const BillingAddressContainer = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const BillingAddressCheckbox = styled("div")(() => ({
  marginTop: "8px",
}));

export default styles;
